import { createRouter, createWebHistory } from "vue-router"
import HomeView from "../views/HomeView.vue"

const DEFAULT_TITLE = "TUC"
// const BASE_DIR = "/web/tuc/"

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "TUC – Главная" },
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/products",
    name: "products",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ProductsView.vue"),
  },
  {
    path: "/products/:id",
    name: "product",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ProductView.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TermsView.vue"),
  },
  {
    path: "/pol",
    name: "pol",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PolView.vue"),
  },
  {
    path: "/cookie",
    name: "cookie",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CookieView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PageNotFound.vue"),
  },
]

const router = createRouter({
  // history: createWebHistory("/web/tuc/"),
  history: createWebHistory("/"),
  routes,
  scrollBehavior() {
    // to, from, savedPosition
    // always scroll to top
    return { top: 0, behavior: "smooth" }
  },
})

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE
})

export default router
